
import { Routes, Route } from "react-router-dom";
import ComingSoon from "./pages/ComingSoon";
import Index from "./pages/Index";
import ChatWithClaude from "./pages/ChatWithClaude";
import StrategyDeckPrompt from "./pages/StrategyDeckPrompt";
import SoftSkillsAIEra from "./pages/SoftSkillsAIEra";
import CopilotCoaching from "./pages/CopilotCoaching";
import BlogPost from "./pages/BlogPost";
import Impressum from "./pages/Impressum";
import Speaking from "./pages/Speaking";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/chat-with-claude" element={<ChatWithClaude />} />
      <Route path="/strategy-deck-prompt" element={<StrategyDeckPrompt />} />
      <Route path="/soft-skills-ai-era" element={<SoftSkillsAIEra />} />
      <Route path="/strategic-sparring-partner" element={<CopilotCoaching />} />
      <Route path="/speaking" element={<Speaking />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/impressum" element={<Impressum />} />
    </Routes>
  );
}

export default App;
